import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Container } from '../ui/Container';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  return <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/80 backdrop-blur-md" data-id="element-147">
      <Container data-id="element-148">
        <div className="flex h-16 items-center justify-between" data-id="element-149">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-150">
            <Link to="/" className="flex items-center space-x-2" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/dPM9KUkaUrxRQPXFhc49CA/flowsense.png" alt="Flowsense" className="h-8 w-8" data-id="element-152" />
              <span className="text-xl font-bold text-gray-900" data-id="element-153">Flowsense</span>
            </Link>
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:block" data-id="element-154">
            <div className="flex items-center space-x-4" data-id="element-155">
              <a href="https://go.useflowsense.com/signup" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-156">
                Sign In
              </a>
              <a href="https://app.useflowsense.com/auth/signup" data-id="element-157">
                <Button size="sm" noGradient data-id="element-158">
                  Signup Free
                </Button>
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-159">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary" data-id="element-160">
              <span className="sr-only" data-id="element-161">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-162" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-163" />}
            </button>
          </div>
        </div>
      </Container>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden" data-id="element-164">
          <div className="border-t border-gray-200 pb-4 pt-4" data-id="element-165">
            <div className="flex flex-col space-y-3 px-4" data-id="element-166">
              <a href="https://app.useflowsense.com/auth/login" className="block text-base font-medium text-gray-600 hover:text-gray-900" data-id="element-167">
                Sign In
              </a>
              <a href="https://app.useflowsense.com/auth/signup" data-id="element-168">
                <Button className="w-full justify-center" noGradient data-id="element-169">
                  Signup Free
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}